import { render } from "./adminDIDNumbers.vue?vue&type=template&id=34976a8f&scoped=true"
import script from "./adminDIDNumbers.vue?vue&type=script&lang=js"
export * from "./adminDIDNumbers.vue?vue&type=script&lang=js"

import "./adminDIDNumbers.vue?vue&type=style&index=0&id=34976a8f&scoped=true&lang=scss"
import "./adminDIDNumbers.vue?vue&type=style&index=1&id=34976a8f&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34976a8f"]])

export default __exports__